var finansudd = finansudd || {};

finansudd.courselist = new function() {

	var self = this,
		courseCount = 1;

	// Helper for getting the queryString
	var urlParams = function () {
	    // This function is anonymous, is executed immediately and 
	    // the return value is assigned to QueryString!
	    var query_string = {};
	    var query = window.location.search.substring(1);
	    var vars = query.split("&");
	    for (var i = 0; i < vars.length; i++) {
	        var pair = vars[i].split("=");
	        // If first entry with this name
	        if (typeof query_string[pair[0]] === "undefined") {
	            query_string[pair[0]] = decodeURIComponent(pair[1]);
	            // If second entry with this name
	        } else if (typeof query_string[pair[0]] === "string") {
	            var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
	            query_string[pair[0]] = arr;
	            // If third or later entry with this name
	        } else {
	            query_string[pair[0]].push(decodeURIComponent(pair[1]));
	        }
	    }
	    return query_string;
	}();

	function clearURLParams() {
		urlParams = {};
	}

	// Converts the #2134,2543 into a proper querystring
	function convertHashToQuery() {
		var hash = window.location.hash.replace("#", "");
		window.location.hash = "";

		if(hash != "") {
			urlParams.filter = hash;
			newUrl = UpdateQueryString("filter", hash);
			history.pushState({}, document.title, newUrl);
		}
	}

	function UpdateQueryString(key, value, url) {
	    if (!url) url = window.location.href;
	    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
	        hash;

	    if (re.test(url)) {
	        if (typeof value !== 'undefined' && value !== null)
	            return url.replace(re, '$1' + key + "=" + value + '$2$3');
	        else {
	            hash = url.split('#');
	            url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
	            if (typeof hash[1] !== 'undefined' && hash[1] !== null) 
	                url += '#' + hash[1];
	            return url;
	        }
	    }
	    else {
	        if (typeof value !== 'undefined' && value !== null) {
	            var separator = url.indexOf('?') !== -1 ? '&' : '?';
	            hash = url.split('#');
	            url = hash[0] + separator + key + '=' + value;
	            if (typeof hash[1] !== 'undefined' && hash[1] !== null) 
	                url += '#' + hash[1];
	            return url;
	        }
	        else
	            return url;
	    }
	}


	this.initCourses = function () {
	    if ($("#course-list").length) {
	        convertHashToQuery();
	        self.setUrlParams();
	        self.initFromUrl();
	    }

		if ($("#course-slider").length) {
			self.loadCourseSlider(1);
		}

	}

	this.setUrlParams = function() {

		$('.course-list').on('click', '.courselist-item', function(event) {
			var $this = $(this);
			var id = $this.data('id');
			var p = $this.data('page');

			// Create the new url
			var newUrl = "";
			if(id != null && id != "") {
				newUrl = UpdateQueryString("id", id, newUrl);				
			}

			if(p != null && p != "") {
				newUrl = UpdateQueryString("page", p, newUrl);				
			}

			// Set the url
			history.pushState({}, document.title, newUrl);
		})
	}

	this.initFromUrl = function() {

        if (typeof urlParams.filter !== "undefined" && urlParams.filter != null)
        {	
        	var filterIdArray = urlParams.filter.split(",");
    		$(".course-filter").val(filterIdArray);

    		setTimeout(function() {
    			$('.course-filter').change();
    		}, 100);

        }

	    // Set all the filters
	    if(typeof urlParams.sort !== "undefined" && urlParams.sort != null) {
	    	$('#course-sort').val(urlParams.sort);

	    	setTimeout(function() {
	    		$('#course-sort').change();
	    	}, 100);
	    }
	    
        setTimeout(function() {
        	
	        // Load the courses
			if (urlParams.page !== "undefined" && urlParams.page != null) {
				var tmp = urlParams.page * 1;
	            self.loadCourses(tmp, false, true);
		    } else {
		    	self.loadCourses(1);
		    }

		    // Init the filtering
		    self.activeFilters();
        }, 200);


	}


	this.getMoreCourses = function() {
		var $item = $('.ajax-content > .courselist-item'),
			itemLength = parseInt($('.filter-count > span').first().html());

		// Only run the event if there are items to load
		if(itemLength != $item.length) {

			// Load more courses when the div is visible and increment the page-count with 1
			if($('#loadmore').visible()) {
				self.loadCourses(courseCount, true);
			}

			//Show the cta-banner
			if($('.courselist-item:nth-of-type(9)').visible() && $('.cta-banner').hasClass('not-shown')) {
				$('.cta-banner').removeClass('not-shown');
			}


		} else {

			$('#loadmore').hide();
		}
	}

	this.activeFilters = function () {
		var filters = $("select.course-filter");

		filters.on('change', function () {
			var $this = $(this);
			self.loadCourses(1);

		});
	}

	this.setFilters = function(obj) {
		var newUrl = window.location.href;

		if(obj.sort !== "undefined" && obj.sort != null) {
			urlParams.sort = obj.sort
			newUrl = UpdateQueryString("sort", obj.sort, newUrl);
		}

		if(obj.filter !== "undefined" && obj.filter != null && obj.filter.length) {
			newUrl = UpdateQueryString("filter", obj.filter, newUrl);
		}

		// Set the url
		history.pushState({}, document.title, newUrl);

	}
	
	this.loadCourses = function (page, append, dontSkipItems) {

		var favorites = [];
		var subjectAreas = [];
		var types = [];
		var targetAudiences = [];

		var params = {
			"sort": $("#course-sort").val(),
			"getSubjectAreaValues": $("#filterid-3130").val() != null ? $("#filterid-3130").val() : [],
			"getTypesValues": $("#filterid-3151").val() != null ? $("#filterid-3151").val() : [],
			"getTargetAudienceValues": $("#filterid-4397").val() != null ? $("#filterid-4397").val() : []
		};

		// Create a filter array with all filters
		params.filter = [].concat.apply([], [params.getSubjectAreaValues, params.getTypesValues, params.getTargetAudienceValues]);

		// Set the filters in the url
		self.setFilters(params);

		// Reset the counter
		courseCount = page + 1;



		var filterValues = JSON.stringify({
			"Mode":"list",
			"Favorites": favorites,
			"SubjectAreas": params.getSubjectAreaValues,
			"Types": params.getTypesValues,
			"TargetAudiences": params.getTargetAudienceValues,
			"SortOrder": params.sort,
			"CurrentPageId": 0,
			//"MaxItems": 12,
			"Page": page,
			"DontSkipItems": dontSkipItems ? true : false
		});

		$.ajax({
			url: "/settings/courseListView/",
			type: 'POST',
			cache: false,
			contentType: "html/text; charset=utf-8",
			dataType: 'html',
			data: filterValues,
			success: function(data) {

				if(append) {
					var courseItems = $(data).siblings('.ajax-content').html();
					$("#course-list").find('.ajax-content').append(courseItems);
				} else {

					var itemCount = $(data).siblings('.item-count').text();
					$('.ajax-filter .filter-count > span').html(itemCount);

					$("#course-list").html(data);

					// Scroll to the previous item
					if(urlParams.id != "" && urlParams.id != null) {
						setTimeout(function() {
							finansudd.scrollTo.scrollTarget("[data-id=" + urlParams.id + "]", 0);							

							// Set the id to null to prevent a scroll on filter
							urlParams.id = null;
						}, 2000);

					}
					
					self.getMoreCourses();
				}



				novicell.responsiveImages.init();
				finansudd.favorites.setFavoritesOnlist();
		
			},
			error: function (data, errorThrown) {
				console.log(errorThrown);
				$("#course-list").html('<div class="ajax-content error-msg">Der er desværre sket en fejl </br></br> <button class="btn btn-blue light" onclick="location.reload();"> Genindlæs siden </button></div>');
			}
		});
	}


	this.loadCourseSlider = function (page) {
		var subjectAreas = $(".course-wrapper").data("subjectarea");
		
		var subjectAreasArray = subjectAreas != undefined ? subjectAreas.split(",").clean("") : null;
		var favorites = [];
		var targetAudiences = [];
		var types = [];
		var sort = $("#course-sort").val();
		var excludeCurrentPageId = $(".course-wrapper").data("currentpageid");

		if (subjectAreasArray == null) {
			subjectAreasArray = [];
		}

		var filterValues = JSON.stringify({
			"Mode": "slider",
			"Favorites": favorites,
			"SubjectAreas": subjectAreasArray,
			"Types": types,
			"TargetAudiences": targetAudiences,
			"SortOrder": sort,
			"CurrentPageId": excludeCurrentPageId,
			"Page": page
		});

		$.ajax({
			url: "/settings/courseListView/",
			type: 'POST',
			cache: false,
			contentType: "html/text; charset=utf-8",
			dataType: 'html',
			data: filterValues,
			success: function (data) {
				$("#course-slider").html(data)
				finansudd.slider.newsSlider($('#course-slider'));
				novicell.responsiveImages.init();
			},
			error: function (data, errorThrown) {
				console.log(errorThrown)
			}
		});
	}

	this.loadFavorites = function (page, favorites) {

		//Convert string to array
		var favoriteArr = favorites.split(',');
		if (favoriteArr.length == 1 && favoriteArr[0] == "") {
			favoriteArr = [];
		}

		var favorites = favoriteArr;

		var filterValues1 = JSON.stringify({
			"Mode": "favorites",
			"Favorites": favorites,
			"CurrentPageId": 0,
			"DocType": "Courses", 
			"Page": page
		});

		$.ajax({
			url: "/settings/courseListView/",
			type: 'POST',
			cache: false,
			contentType: "html/text; charset=utf-8",
			dataType: 'html',
			data: filterValues1,
			success: function (data) {
				$("#course-favorites").html(data);
			},
			error: function (data, errorThrown) {
				console.log(errorThrown);
			}
		});

		var filterValues2 = JSON.stringify({
			"Mode": "favorites",
			"Favorites": favorites,
			"CurrentPageId": 0,
			"DocType": "Curricula",
			"Page": page
		});

		$.ajax({
			url: "/settings/courseListView/",
			type: 'POST',
			cache: false,
			contentType: "html/text; charset=utf-8",
			dataType: 'html',
			data: filterValues2,
			success: function (data) {
				$("#curricula-favorites").html(data);
			},
			error: function (data, errorThrown) {
				console.log(errorThrown);
			}
		});

	}

}